import React from 'react';
import { Link, Flex } from '@gravity-ui/uikit';
import { ProfilesRecord } from '../../components/Page/types/ProfilesRecord';
import { QuestionIconPopover } from '../../components/ui/QuestionIconPopover/QuestionIconPopover';
import { DEFAULT_PROFILE } from '../../components/Page/consts/DEFAULT_PROFILE';
import { pageT } from '../../i18n/page.i18n';

type ProfileOption = {
    value: string;
    content: React.ReactNode;
    disabled: boolean;
};

/**
 * Создает опции для селектора профилей с добавлением иконки вопроса
 * для профиля 'allstaff_outstaff_ext' если он недоступен
 */
export function getProfileOptions(profiles: ProfilesRecord): ProfileOption[] {
    return Object.entries(profiles).map(([key, value]) => ({
        value: key,
        content:
            key === 'allstaff_outstaff_ext' && value.disabled ? (
                <Flex gap={1} alignItems="center">
                    <span>{value.description || key}</span>
                    <QuestionIconPopover
                        popoverContent={
                            <Flex style={{ padding: '4px' }}>
                                <Link href="https://nda.ya.ru/t/xBZpKSZb743Fha" target="_blank">
                                    {pageT('orderAccess')}
                                </Link>
                            </Flex>
                        }
                        style={{
                            display: 'inline-flex',
                            alignItems: 'center',
                        }}
                    />
                </Flex>
            ) : (
                value.description || key
            ),
        disabled: value.disabled ?? false,
    }));
}

export function getDefaultProfile(
    profiles: ProfilesRecord,
    preferredProfile: string = DEFAULT_PROFILE,
): string {
    if (preferredProfile in profiles && !profiles[preferredProfile].disabled) {
        return preferredProfile;
    }

    const firstAvailable = Object.entries(profiles).find(([, value]) => !value.disabled);

    return firstAvailable ? firstAvailable[0] : '';
}
